import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  IGetCompanyResult,
  IGetCurrencies,
  IGetDialCodes,
} from "./interfaces/api-company-interfaces";

const URLs = {
  getCompany: "/company",
  getLogo: "/company/logo",
  getTranslation: "/translations",
  getDialCodes: "/dial-codes",
  getCurrencies: "/currencies",
};
class ApiCompany extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getCompany = (): Promise<IGetCompanyResult> => {
    return this.get(URLs.getCompany, {});
  };
  getLogo = (): Promise<IGetCompanyResult> => this.get(URLs.getLogo, {});
  getDialCodes = (): Promise<IGetDialCodes> => this.get(URLs.getDialCodes, {});
  getAllTranslations = (): Promise<{
    result: {
      id: number;
      language: "AR" | "EN";
      slug: string;
      translation: string;
    }[];
  }> => this.get(URLs.getTranslation, {});
  AddTranslate = (body: {
    slug: string;
    translation: string;
    language: "AR" | "EN";
  }): Promise<any> => {
    return this.post("/translations", { ...body });
  };
  editTran = (body: { id: number; translation: string }): Promise<any> => {
    return this.put("/translations/" + body.id, {
      translation: body.translation,
    });
  };
  deleteTrans = (body: { id: number }): Promise<any> => {
    return this.delete("/translations/" + body.id);
  };
  postBulk = (body: { file: File }) => {
    const formData = new FormData();
    formData.append("file", body.file);
    return this.post("/translations/bulk", formData);
  };
  getCurrencies = (): Promise<IGetCurrencies> => {
    return this.get(URLs.getCurrencies, {});
  };
}
export default ApiCompany;
